import React from "react";
import useAccessibleDialog from "./useAccessibleDialog";

const MenuOverlay = ({ onClose, onLeaderboard, onStats }) => {
  const dialogRef = useAccessibleDialog(onClose);
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 600px)").matches;

  const backdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: isMobile ? "100dvh" : "100vh", // <-- fix: true viewport height on mobile
    background: "#082f26",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Baskerville', serif",
    zIndex: 99999,
  };

  const panelStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5rem",
    width: "min(90%, 400px)",
    zIndex: 100001,
  };

  const buttonStyle = {
    width: "100%",
    padding: "1.5rem 2rem",
    fontSize: "1.5rem",

    fontWeight: "bold",
    borderRadius: "12px",
    background: "#034c39",
    color: "#e7c17f",
    border: "none",
    cursor: "pointer",
    transition: "transform 0.2s ease, filter 0.2s ease",
    fontFamily: "'Baskerville', serif",
  };

  return (
    <div style={backdropStyle}>
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="game-menu-title"
        tabIndex={-1}
        style={panelStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="game-menu-title" className="visually-hidden">Game menu</h2>
        <button onClick={onStats} style={buttonStyle}>My Stats</button>
        <button onClick={onLeaderboard} style={buttonStyle}>Leaderboard</button>
        <button onClick={onClose} style={buttonStyle} data-dialog-initial-focus>Return to Game</button>
      </div>
    </div>
  );
};

export default MenuOverlay;
